function Spacer() {
  return <div style={{ height: "56px" }}> &nbsp;</div>;
}

export default Spacer;
